import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Select } from '@agconnections/grow-ui';
import { hydrologyGroups } from '../DataSets';

const HydrologyGroup = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Select}
      type="text"
      id="hydrologyGroup"
      name="hydrologyGroup"
      items={hydrologyGroups}
      label="Hydrology Group"
      disabled={!isEnableInfoTabEdit}
      placeholder="Select hydrology group"
    />
  );
};

export default HydrologyGroup;
